module.exports = __webpack_public_path__ + "static/media/img-6.18872898.jpg";